import React from 'react';
import { Form, Input, Select, Button } from 'antd';
import Navbar from './Navbar';
import './UserProfile.css';

const { Option } = Select;

const UserProfile = () => {
  const onFinish = (values) => {
    console.log('Form values:', values);
  };

  return (
    <>
      <Navbar />
      <div className="user-profile-container">
        <h2>User Profile</h2>
        <Form layout="vertical" onFinish={onFinish}>
          <div className="name-row">
            <Form.Item label="First Name" className="name-field">
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item label="Last Name" className="name-field">
              <Input placeholder="Last Name" />
            </Form.Item>
          </div>
          <div className="dual-row">
            <Form.Item label="Gender" className="dual-field">
              <Select placeholder="Select gender" allowClear>
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
                <Option value="other">Other</Option>
              </Select>
            </Form.Item>
            <Form.Item label="Household Type" className="dual-field">
              <Select placeholder="Select Household Type" allowClear>
                <Option value="single">Single</Option>
                <Option value="couple">Couple</Option>
                <Option value="family">Family</Option>
              </Select>
            </Form.Item>
          </div>
          <h3>Current Location</h3>
          <Form.Item label="Street number and name or cross-streets">
            <Input placeholder="Street number and name or cross-streets" />
          </Form.Item>
          <div className="location-row">
            <Form.Item label="City" className="location-field">
              <Input placeholder="City" />
            </Form.Item>
            <Form.Item label="Zip Code" className="location-field">
              <Input placeholder="Zip Code" />
            </Form.Item>
          </div>
          <div className="location-row">
            <Form.Item label="Country" className="location-field">
              <Input value="United States" disabled />
            </Form.Item>
            <Form.Item label="State" className="location-field">
              <Select placeholder="Select State" allowClear>
                <Option value="CA">California</Option>
                <Option value="NY">New York</Option>
                <Option value="TX">Texas</Option>
              </Select>
            </Form.Item>
          </div>
          <Form.Item label="Housing Status">
            <Select placeholder="Select housing status" allowClear>
              <Option value="owned">Owned</Option>
              <Option value="rented">Rented</Option>
              <Option value="other">Other</Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="save-button">
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default UserProfile;